import script from "./MapButtons.vue?vue&type=script&setup=true&lang=js"
export * from "./MapButtons.vue?vue&type=script&setup=true&lang=js"

import "./MapButtons.vue?vue&type=style&index=0&id=ba8c9d54&lang=css"

const __exports__ = script;

export default __exports__